import React from "react";
import { useTranslation } from "react-i18next";

import { useAppContext } from "@/contexts";
import { type PhqOption, usePhq } from "@/hooks";
import { shouldAskBaselineOutcomes } from "@/utils/survey/outcomes";

import { QuestionComponentProps, QuestionDefinition } from "../../../Question";
import { MultipleChoiceQuestion } from "../../core";

const QUESTION_ID = "phq2";

declare module "@/contexts" {
  interface SurveyAnswers {
    phq2?: PhqOption;
  }
}

const Phq2Question: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
  surveyAnswers,
}) => {
  const { surveyMetadata } = useAppContext();
  const { phqOptions } = usePhq();
  const { t } = useTranslation();

  const questionText =
    surveyMetadata?.name === "RECURRING_OUTCOMES"
      ? t("phq2.questionText.recurringOutcomes")
      : t("phq2.questionText.enrollment");

  return (
    <MultipleChoiceQuestion
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      options={phqOptions}
      questionId={QUESTION_ID}
      questionText={questionText}
      selectedItem={surveyAnswers[QUESTION_ID] || ""}
    />
  );
};

export const Q_PHQ_2: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: [
    "WEIGHT",
    "MOOD",
    "DPP",
    "DIABETES_LIFESTYLE",
    "MED",
    "NMPBA",
  ],
  shouldShowQuestion: ({ partnerInfo }) =>
    shouldAskBaselineOutcomes(partnerInfo),
  component: Phq2Question,
};

export const Q_RETRIAGE_PHQ_2: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["MED", "NMPBA"],
  shouldShowQuestion: () => true,
  component: Phq2Question,
};
